import { FirebaseFields } from 'src/types'

import firestoreService from 'src/api/service'

import {
  FullServiceContactsProps,
  ServiceContact,
  UpdateServiceContactsProps,
} from 'src/api/ServiceContacts/types'

export async function getServiceContacts(): Promise<
  FullServiceContactsProps[]
> {
  return firestoreService.getCollectionData<FullServiceContactsProps>(
    FirebaseFields.HISTORY_OF_SERVICE_CONTACTS,
  )
}

export async function addServiceContact(
  payload: ServiceContact,
): Promise<void> {
  return firestoreService.addDataToCollection(
    FirebaseFields.HISTORY_OF_SERVICE_CONTACTS,
    payload,
  )
}

export async function updateServiceContact({
  id,
  payload,
}: UpdateServiceContactsProps): Promise<void> {
  return firestoreService.updateDataInCollection(
    FirebaseFields.HISTORY_OF_SERVICE_CONTACTS,
    id,
    payload,
  )
}

export async function deleteServiceContact(id: string): Promise<void> {
  return firestoreService.deleteDataFromCollection(
    FirebaseFields.HISTORY_OF_SERVICE_CONTACTS,
    id,
  )
}
